"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpBarChartGrouped = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var merge_1 = __importDefault(require("lodash/merge"));
var chart_js_1 = require("chart.js");
var format_percentage_helper_1 = require("../../../api/helpers/format-percentage.helper");
var DpChart_1 = require("../Charts/DpChart");
var DpBarChartGrouped_styled_1 = require("./DpBarChartGrouped.styled");
var react_1 = require("react");
var api_1 = require("../../../api");
var gridLinesColor = 'rgb(184, 189, 194)';
var DpBarChartGrouped = function (_a) {
    var datasets = _a.datasets, labels = _a.labels, options = _a.options, plugins = _a.plugins, ariaLabel = _a.ariaLabel, _b = _a.showPercentageOnBarTop, showPercentageOnBarTop = _b === void 0 ? true : _b, _c = _a.barGroupWidth, barGroupWidth = _c === void 0 ? 160 : _c, _d = _a.barChartHeight, barChartHeight = _d === void 0 ? 150 : _d, props = __rest(_a, ["datasets", "labels", "options", "plugins", "ariaLabel", "showPercentageOnBarTop", "barGroupWidth", "barChartHeight"]);
    // ----------------------------------------- Constants
    var chartRef = (0, react_1.useRef)(null);
    var _e = (0, react_1.useState)(true), isChartResponsive = _e[0], setIsChartResponsive = _e[1];
    var setChartResponsive = (0, react_1.useCallback)(function () {
        var _a, _b;
        var calculatedBarGroupWidth = ((_a = chartRef === null || chartRef === void 0 ? void 0 : chartRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) / (datasets ? (_b = datasets[0]) === null || _b === void 0 ? void 0 : _b.data.length : 1);
        setIsChartResponsive(calculatedBarGroupWidth >= barGroupWidth);
    }, [chartRef, setIsChartResponsive, datasets, barGroupWidth]);
    var chartOptions = (0, react_1.useMemo)(function () {
        var _a;
        return ({
            // These attributes are not supported in Chart.js
            height: barChartHeight,
            width: barGroupWidth * (datasets ? (_a = datasets[0]) === null || _a === void 0 ? void 0 : _a.data.length : 1),
            // ...............................................
            responsive: isChartResponsive,
            maintainAspectRatio: false,
            hover: {
                mode: 'index',
                intersect: false,
            },
            layout: {
                padding: {
                    top: 15,
                    bottom: 0,
                },
            },
            tooltips: {
                mode: 'index',
                intersect: false,
            },
            scales: {
                yAxes: [
                    {
                        gridLines: {
                            drawTicks: false,
                            color: gridLinesColor,
                            borderDash: [2],
                            zeroLineColor: gridLinesColor,
                        },
                        ticks: {
                            fontStyle: 'bold',
                            callback: function (value) { return (value > 0 ? "".concat(value, "% ") : ''); },
                        },
                    },
                ],
                xAxes: [
                    {
                        ticks: {
                            lineHeight: 1.2,
                            fontStyle: 'bold',
                        },
                    },
                ],
            },
        });
    }, [isChartResponsive, datasets, barChartHeight, barGroupWidth]);
    var barTopPercentageStatusPlugin = (0, react_1.useMemo)(function () {
        return showPercentageOnBarTop
            ? {
                afterDatasetsDraw: function (component) {
                    var ctx = component.ctx;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'bottom';
                    var fontSize = 9;
                    ctx.font = chart_js_1.helpers.fontString(fontSize, 'normal', 'Circular Std');
                    component.data.datasets.forEach(function (_a, datasetIndex) {
                        var data = _a.data;
                        var metaData = component.getDatasetMeta(datasetIndex).data;
                        metaData.forEach(function (_a, index) {
                            var _model = _a._model;
                            if (data[index] > 0) {
                                ctx.fillText("".concat((0, format_percentage_helper_1.formatPercentage)(data[index]), "%"), _model.x, _model.y - 3);
                            }
                        });
                    });
                },
            }
            : {};
    }, [showPercentageOnBarTop]);
    (0, api_1.useMount)(function () {
        setChartResponsive();
        window.addEventListener('resize', setChartResponsive);
        return function () {
            window.removeEventListener('resize', setChartResponsive);
        };
    });
    return ((0, jsx_runtime_1.jsx)(DpBarChartGrouped_styled_1.StyledDpBarChartGrouped, { "data-testid": "DpBarLChartGrouped", ref: chartRef, isResponsive: chartOptions.responsive, tabIndex: isChartResponsive ? -1 : 0, children: (0, jsx_runtime_1.jsx)(DpChart_1.DpChart, __assign({ datasets: datasets || [], labels: labels || [], plugins: plugins || barTopPercentageStatusPlugin, options: (0, merge_1.default)(chartOptions, options || {}), ariaLabel: ariaLabel }, props)) }));
};
exports.DpBarChartGrouped = DpBarChartGrouped;
exports.default = exports.DpBarChartGrouped;
